import { collection, doc, setDoc, getDocs, query, where, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

const CR = "changeRequests";

export async function createChangeRequest(caseId, version, { authorId, authorName, note }) {
  const ref = doc(collection(db, CR));
  await setDoc(ref, {
    id: ref.id,
    caseId,
    version,
    authorId,
    authorName,
    note,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

export async function listChangeRequests(caseId) {
  const q = query(collection(db, CR), where("caseId", "==", caseId));
  const snap = await getDocs(q);
  return snap.docs
    .map((d) => {
      const data = d.data();
      return { id: d.id, ...data, _ts: data.createdAt?.toMillis?.() ?? null };
    })
    .sort((a, b) => (a._ts ?? 0) - (b._ts ?? 0));
}
